var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('input',{staticClass:"checkbox__option",attrs:{"type":"checkbox","id":_vm.data.value},domProps:{"checked":_vm.value},on:{"change":_vm.change}}),_vm._v(" "),_c('label',{staticClass:"checkbox__option-label",attrs:{"for":_vm.data.value}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }